export const MY_ROLE_FILTER = 'my-role';
export const ALL_FILTER = 'all';
export const CUSTOM_FILTER = 'custom';
export const PROJECT_MANAGER_FILTER = 'p';
export const SUPERVISOR_FILTER = 's';
export const TEAM_MEMBER_FILTER = 't';
